import { GoogleApiWrapper } from 'google-maps-react'
import Map from './Map'
import config from 'lib/config'

export default GoogleApiWrapper({
  apiKey: config.GOOGLE_API_KEY,
})(Map)
